export default [
  {
    path: '/main/arenavehicles2001',
    meta: {
      tag: 'arena_vehicles_2001',
      name: 'Veículos Arena 2001',
      breadcrumb: 'Veículos Arena 2001'
    },
    component: () => import(/* webpackChunkName: "arena_vehicles_2001" */ '@/views/main/settings/parameters/arenaVehicles2001/Index.vue'),
    children: [
      {
        path: '',
        name: 'listarenavehicles2001',
        meta: {
          tag: 'arena_vehicles_2001',
          name: 'Veículos Arena 2001',
          menu: 'settings'
        },
        component: () => import(/* webpackChunkName: "arena_vehicles_2001" */ '@/views/main/settings/parameters/arenaVehicles2001/List.vue'),
      }
    ]
  }
]